import styled from 'styled-components';

export const Wrapper = styled.section``;
export const LabelNotification = styled.p``;
